export default "__VITE_ASSET__DImIQk03__"